module.exports = __webpack_public_path__ + "img/Collectium-logo.114485c5.svg";